import { motion } from 'framer-motion'
import React, { useRef } from 'react'
import PersonCard from '../atoms/PersonCard'
import slugify from 'slugify'

const PersonListCity = ({
  city,
  index,
  activeIndex,
  onToggle,
  onMouseEnter,
  onMouseLeave,
}) => {
  const isOpen = index === activeIndex
  const hideBorder = activeIndex === index + 1
  const ref = useRef()

  return (
    <div
      ref={ref}
      id={slugify(city?.title).toLowerCase()}
      className={`px-5 sm:px-7 md:px-8 lg:px-10 group transition ${
        isOpen && 'bg-white'
      }`}
    >
      <div
        className={`border-b transition ${
          isOpen ? 'border-transparent' : 'border-gray-4'
        } ${index === 0 && 'border-t'} ${hideBorder && 'border-b-transparent'}`}
      >
        <button
          type="button"
          className={`py-5.5 flex items-center justify-between w-full px-3 text-base font-bold ${
            !isOpen && 'group-hover:text-red'
          } transition`}
          onClick={onToggle}
          onMouseEnter={() => onMouseEnter(ref.current)}
          onMouseLeave={() => onMouseLeave(ref.current)}
        >
          <span>{city.title}</span>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="22"
            height="22"
            fill="none"
            viewBox="0 0 22 22"
          >
            {isOpen ? (
              <path
                stroke="#000"
                strokeLinecap="round"
                strokeWidth="2"
                d="M3 11h16"
              ></path>
            ) : (
              <path
                stroke="#000"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M11 3v8H3M19 11h-8v8"
              ></path>
            )}
          </svg>
        </button>
        <div className="overflow-hidden">
          <motion.div style={{ height: isOpen ? 'auto' : 0 }}>
            <div className="px-3 pb-16 pt-7">
              {city.cityGroups?.map(group => (
                <div key={group.id} className="pb-16">
                  {group.heading && (
                    <h3 className="mb-5 u-h3">{group.heading}</h3>
                  )}

                  <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-3">
                    {group.people?.map(person => (
                      <PersonCard
                        key={person.id}
                        name={person.teamMemberDetails[0].memberName}
                        title={person.teamMemberDetails[0].memberTitle}
                        phone={person.teamMemberDetails[0].phoneNumber}
                        email={person.teamMemberDetails[0].email}
                        pictureUrl={
                          person.teamMemberDetails[0].photo
                            ? person.teamMemberDetails[0].photo[0]?.url
                            : null
                        }
                      />
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </motion.div>
        </div>
      </div>
    </div>
  )
}

export default PersonListCity
